import Home from '@material-ui/icons/Home'
import React from 'react'
import { Box } from 'webbook-airways'
import { Breadcrumb } from './Breadcrumb'

export function Breadcrumbs({ children, noHome }) {
  const breadcrumbs = !Array.isArray(children)
    ? [children]
    : children?.filter(child => child !== false)
  return (
    <Box vAlign="center" style={{ height: '100%', marginLeft: -8 }}>
      {!noHome && (
        <>
          <Breadcrumb to="/">
            <Home style={{ marginTop: 8, marginLeft: 8 }} />
          </Breadcrumb>
          <Separator />
        </>
      )}
      {breadcrumbs?.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {breadcrumbs?.filter(child => child !== false).length - 1 !==
            index && <Separator />}
        </React.Fragment>
      ))}
    </Box>
  )
}

function Separator() {
  return (
    <div
      style={{
        height: '100%',
        width: 1,
        backgroundColor: 'rgba(0,0,0,0.05)',
        transform: 'skewX(-15deg)'
      }}
    />
  )
}
